import { render, staticRenderFns } from "./customer_merge.vue?vue&type=template&id=f1f9cd94&"
import script from "./customer_merge.vue?vue&type=script&lang=js&"
export * from "./customer_merge.vue?vue&type=script&lang=js&"
import style0 from "./customer_merge.vue?vue&type=style&index=0&id=f1f9cd94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports